export default "<ul>\n    <li *ngFor=\"let tag of tags\">\n        <a class=\"tag\">{{ tag }}</a>\n    </li>\n</ul>"